import { Path, UseFormReturn, useWatch } from "react-hook-form";

import { useTranslation } from "../../core/translation.core";
import { ProductFormData, ProductType } from "../../types/product";

export default function ProductTypeSelector({ methods }: { methods: UseFormReturn<ProductFormData> }) {
  const { t, msg } = useTranslation();

  return (
    <div className="my-4 grid gap-4 grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 max-w-[1200px]">
      <Grid methods={methods} productType="simple" title={t(msg.product.simple)} description="" />
      <Grid methods={methods} productType="variationParent" title={t(msg.product.variationParent)} description="" />
      <Grid methods={methods} productType="custom" title={t(msg.product.custom)} description="" />
      <Grid methods={methods} productType="bundle" title={t(msg.product.bundleProducts)} description="" />
      <Grid methods={methods} productType="giftCard" title={t(msg.product.giftCard)} description="" />
    </div>
  );
}

interface Props {
  title: string;
  description: string;
  productType: ProductType;
  methods: UseFormReturn<ProductFormData>;
}

function Grid({ title, description, productType, methods }: Props) {
  const watchingProductType = useWatch({
    name: "productType",
    control: methods.control,
  });

  const isSelected = productType === watchingProductType;

  const btnCss =
    "border flex flex-col items-center gap-4 p-4 cursor-pointer rounded-md " +
    (isSelected ? "border-her-dodgerblue text-her-dodgerblue bg-[#3880e71a] " : "");

  return (
    <button
      data-producttype={productType}
      className={btnCss}
      type="button"
      onClick={() => {
        methods.setValue("productType" as Path<ProductFormData>, productType);
      }}
    >
      <div className=" font-semibold text-base">{title}</div>
      {description && <div className="text-sm text-center">{description}</div>}
    </button>
  );
}
